<div #wrapper class="row mt-3 d-none d-md-flex container status-nav" [class.status-nav-fixed]="isNavigationFixed">
  <div class="col-sm-12 col-md indicator d-flex flex-column" (click)="scroll('TargetAngabenZurPerson')">
    <div><i class="icon-personendaten"></i>
      <label i18n>Angaben zur Person</label></div>
    <div class="marker mt-auto"
         [class.valid]="isValid('angabenZurPerson')"
         [class.invalid]="!isValid('angabenZurPerson')"></div>
  </div>
  <div class="col-sm-12 col-md indicator d-flex flex-column" (click)="scroll('TargetKontaktdaten')">
    <div><i class="icon-wohnanschrift"></i>
      <label i18n>Kontaktdaten</label></div>
    <div class="marker mt-auto"
         [class.valid]="isValid('kontaktdaten')"
         [class.invalid]="!isValid('kontaktdaten')"></div>
  </div>
  <div class="col-sm-12 col-md indicator d-flex flex-column" (click)="scroll('TargetAusweispapiere')">
    <div><i class="icon-ausweispapiere"></i>
      <label *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" i18n>Ausweispapiere</label>
      <label *ngIf="appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" i18n="@@Unterlagen">Unterlagen</label>
    </div>
    <div class="marker mt-auto"
         [class.valid]="isValid('ausweispapiere')"
         [class.invalid]="!isValid('ausweispapiere')"></div>
  </div>
  <div class="col-sm-12 col-md indicator d-flex flex-column" (click)="scroll('TargetReisedaten')">
    <div><i class="icon-reisedaten"></i>
      <label i18n>Reisedaten</label></div>
    <div class="marker mt-auto"
         [class.valid]="isValid('reisedaten')"
         [class.invalid]="!isValid('reisedaten')"></div>
  </div>
  <div *ngIf="isVisible('referenz')" class="col-sm-12 col-md indicator d-flex flex-column" (click)="scroll('TargetReferenz')">
    <div><i class="icon-einladende-person"></i>
      <label i18n>Referenz</label></div>
    <div class="marker mt-auto"
         [class.valid]="isValid('referenz')"
         [class.invalid]="!isValid('referenz')"></div>
  </div>
  <div *ngIf="appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" class="col-sm-12 col-md indicator d-flex flex-column"
       (click)="scroll('TargetLebensunterhalt')">
    <div><i class="icon-kostenuebernahme"></i>
      <label i18n>Lebensunterhalt</label></div>
    <div class="marker mt-auto"
         [class.valid]="isValid('lebensunterhaltAufenthaltsdetails')"
         [class.invalid]="!isValid('lebensunterhaltAufenthaltsdetails')"></div>
  </div>

  <div *ngIf="isVisible('kostenuebernahme')" class="col-sm-12 col-md indicator d-flex flex-column" (click)="scroll('TargetKostenuebernahme')">
    <div><i class="icon-kostenuebernahme"></i>
      <label i18n>Kostenübernahme</label></div>
    <div class="marker mt-auto"
         [class.valid]="isValid('kostenuebernahme')"
         [class.invalid]="!isValid('kostenuebernahme')"></div>
  </div>

  <div *ngIf="appConfig.umgebung === 'MEK'" class="col-sm-12 col-md indicator d-flex flex-column" (click)="scroll('TargetZusaetzlicheAngaben')">
    <div><i class="icon-reisedaten"></i>
      <label i18n>Zusätzliche Angaben</label></div>
    <div class="marker mt-auto"
         [class.valid]="isValid('zusaetzlicheAngaben')"
         [class.invalid]="!isValid('zusaetzlicheAngaben')"></div>
  </div>

  <div *ngIf="appConfig.umgebung === 'MEK'" class="col-sm-12 col-md indicator d-flex flex-column" (click)="scroll('TargetDokumente')">
    <div><i class="icon-drucker"></i>
      <label i18n>Dokumente</label></div>
    <div class="marker mt-auto"
         [class.valid]="isValid('dokumente')"
         [class.invalid]="!isValid('dokumente')"></div>
  </div>

  <div *ngIf="appConfig.umgebung === 'MEK'" class="col-sm-12 col-md indicator d-flex flex-column" (click)="scroll('TargetLichtbild')">
    <div><i class="icon-fingerabdruck"></i>
      <label i18n>Biometrie</label></div>
    <div class="marker mt-auto"
         [class.valid]="isValid('fingerabdruck') && isValid('lichtbild')"
         [class.invalid]="!isValid('fingerabdruck') || !isValid('lichtbild')"></div>
  </div>

</div>
<div #replacement class="status-nav-replacement" [class.status-nav-fixed]="isNavigationFixed" [style.height]="replacementHeight">&nbsp;</div>
